/* src/app/modules_v2/booking/booking-tabs.component.scss */
/*# sourceMappingURL=booking-tabs.component.css.map */
